import React, { useState, useEffect, useRef, useContext } from "react";
import { api } from "@/services/api";
import ShimmerEffect from "@/components/Shimmer";
import Icone from "@/assets/img/Icon feather-chevron-right.svg";
import { Form } from "@unform/web";
import { Scope } from "@unform/core";
import * as Yup from "yup";
import Input from "@/components/Input";
import InputMask from "@/components/InputMask";
import InputSelect from "@/components/inputSelect";
import InputSelectDinamic from "@/components/InputSelectDinamic";
import InputFile from "@/components/InputFile";
import cepPromise from "cep-promise";
import { equalTo, validateCpf, validadeNewPassword, maskPhone } from "@/utils/validations";
import ModalPopup from "@/components/ModalPopup";
import { Context } from "@/contexts/AuthContext";

import { Container } from "./styles";

export const Profile = () => {
	const { handleLogout } = useContext(Context);
	const formRef = useRef(null);
	const formPet = useRef(null);
	const formImageProfile = useRef(null);
	const formImagePet = useRef(null);
	const [user, setUser] = useState({});
	const [pets, setPets] = useState(null);
	const [loadData, setLoadData] = useState(false);
	const [formUpdateProfile, setFormUpdateProfile] = useState(false);
	const [updateProfile, setUpdateProfile] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [list, setList] = useState(null);
	const [formUpdatePet, setFormUpdatePet] = useState(false);
	const [updatePet, setUpdatePet] = useState(false);
	const [petHasID, setPetHasID] = useState(false);
	const [deletePet, setDeletePet] = useState(false);
	const [formUpdateImageProfile, setFormUpdateImageProfile] = useState(false);
	const [updateImageUser, setUpdateImageUser] = useState(false);
	const [formUpdateImagePet, setFormUpdateImagePet] = useState(false);
	const [updateImagePet, setUpdateImagePet] = useState(false);
	const [petIndex, setPetIndex] = useState(null);
	const [popupDialog, setPopupDialog] = useState(false);
	const [motivo, setMotivo] = useState("");
	const [logOut, setLogOut] = useState(false);

	// peagando dados do usuario
	useEffect(() => {
		getUser();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function getUser() {
		let user = localStorage.getItem("@profile");
		user = JSON.parse(user);
		setUser(user);
		handleSetFormProfile(user);
	}

	// pega dados dos pets
	useEffect(() => {
		getPets();
	}, []);

	function getPets() {
		setLoadData(true);

		api.get("consumer/pets")
			.then((res) => {
				const { status, pets } = res.data;
				if (status === 200) {
					setPets(pets);
				}
			})
			.catch(function (error) {
				console.warn(error);
			})
			.finally(() => setLoadData(false));
	}

	useEffect(() => {
		(async () => {
			const { data } = await api.get("/pet/breeds");
			setList(data);
		})();
	}, []);

	async function handleSubmit(data) {
		Yup.addMethod(Yup.string, "equalTo", equalTo);
		Yup.addMethod(Yup.string, "validateCpf", validateCpf);
		Yup.addMethod(Yup.string, "validadeNewPassword", validadeNewPassword);

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				consumer: Yup.object().shape({
					firstname: Yup.string().required("Campo obrigatório"),
					lastname: Yup.string().required("Campo obrigatório"),
					email: Yup.string()
						.email("E-mail inválido")
						.required("Campo obrigatório"),
					password: Yup.string()
						.optional()
						.validadeNewPassword(
							"A senha deve conter pelo menos 8 caracteres, sendo uma letra maiúscula, uma letra minúscula e um número",
						),
					passwordConfirmation: Yup.string()
						.oneOf([Yup.ref('password'), null], 'As senhas não correspondem'),
					cpf: Yup.string()
						.validateCpf("CPF inválido")
						.required("Campo obrigatório"),
					phone: Yup.string().required("Campo obrigatório"),
					address_components: Yup.object().shape({
						zip_code: Yup.string().required("Campo obrigatório"),
						address: Yup.string().required("Campo obrigatório"),
						number: Yup.number()
							.typeError("Apenas números")
							.positive("Não pode ser 0 ou valor negativo")
							.integer("Apenas números inteiros")
							.required("Campo obrigatório"),
						district: Yup.string().required("Campo obrigatório"),
						city: Yup.string().required("Campo obrigatório"),
						state: Yup.string().required("Campo obrigatório"),
					}),
				}),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdateProfile(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdateProfile({ consumer }) {
		setUpdateProfile(true);

		// deletar password se vazio
		// eslint-disable-next-line eqeqeq
		if (consumer.password == false) {
			delete consumer.password;
		}

		api.post("consumer/profile/update", { consumer })
			.then((res) => {
				if (res.status === 200) {
					api.get("consumer/profile")
						.then((response) => {
							localStorage.setItem(
								"@profile",
								JSON.stringify(response.data.consumer),
							);
							getUser();
							setFormUpdateProfile(false);
							setModalContent({
								title: "Programa Fidelidade GERIOOX",
								content: res.data.message,
							});
							setModalPopup(true);
						})
						.catch((error) => {
							console.error({
								endPoint: "consumer/profile",
								error,
							});
						})
						.finally(() => setUpdateProfile(false));
				}

				if (res.data.status === 401 || res.data.status === 400) {
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				console.error({ endPoint: "/consumer/profile/update", error });
			});
	}

	function handleInputComplete() {
		const zip_code = formRef.current.getFieldValue(
			"consumer.address_components.zip_code",
		);
		let value = zip_code.replace(/[-_.]/g, "").length;

		if (value === 8) {
			cepPromise(zip_code.replace(/[-_.]/g, ""))
				.then((res) => {
					formRef.current.setFieldValue(
						"consumer.address_components.address",
						res.street,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.district",
						res.neighborhood,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.city",
						res.city,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.state",
						res.state,
					);
				})
				.catch(console.error);
		}
	}

	// colocando dados no formulario
	function handleSetFormProfile(user) {
		try {
			user.cpf && formRef.current.setFieldValue("consumer.cpf", user.cpf);
			user.email && formRef.current.setFieldValue("consumer.email", user.email);
			user.firstname && formRef.current.setFieldValue("consumer.firstname", user.firstname);
			user.lastname && formRef.current.setFieldValue("consumer.lastname", user.lastname);
			user.phone && formRef.current.setFieldValue("consumer.phone", user.phone);
			user.localization.address && formRef.current.setFieldValue(
				"consumer.address_components.address",
				user.localization.address,
			);
			user.localization.city && formRef.current.setFieldValue(
				"consumer.address_components.city",
				user.localization.city,
			);
			user.localization.complement && formRef.current.setFieldValue(
				"consumer.address_components.complement",
				user.localization.complement,
			);
			user.localization.district && formRef.current.setFieldValue(
				"consumer.address_components.district",
				user.localization.district,
			);
			user.localization.number && formRef.current.setFieldValue(
				"consumer.address_components.number",
				user.localization.number,
			);
			user.localization.state && formRef.current.setFieldValue(
				"consumer.address_components.state",
				user.localization.state,
			);
			user.localization.zip_code && formRef.current.setFieldValue(
				"consumer.address_components.zip_code",
				user.localization.zip_code,
			);
		} catch (error) {
			return
		}
	}

	// colocando dados do pet no formulario
	function handleSetFormPet(id) {
		formPet.current.setFieldValue(
			"pet.id",
			pets[id]?.id ? pets[id]?.id : "",
		);
		formPet.current.setFieldValue(
			"pet.name",
			pets[id]?.name ? pets[id]?.name : "",
		);
		formPet.current.setFieldValue(
			"pet.kind",
			pets[id]?.kind ? pets[id]?.kind : "",
		);
		formPet.current.setFieldValue(
			"pet.breed",
			pets[id]?.breed ? pets[id]?.breed : "",
		);
		formPet.current.setFieldValue(
			"pet.years_old",
			pets[id]?.years_old ? pets[id]?.years_old : "",
		);
		formPet.current.setFieldValue(
			"pet.weight",
			pets[id]?.weight ? pets[id]?.weight : "",
		);
		formPet.current.setFieldValue(
			"pet.diagnostic",
			pets[id]?.diagnostic ? pets[id]?.diagnostic : "",
		);
		formPet.current.setFieldValue(
			"pet.vet",
			pets[id]?.vet ? pets[id]?.vet : "",
		);
		pets[id]?.id ? setPetHasID(true) : setPetHasID(false);
		setPetIndex(id);
		setFormUpdatePet(true);
	}

	async function handleSubmitPet(data) {
		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				pet: Yup.object().shape({
					name: Yup.string().required("Campo obrigatório"),
					kind: Yup.string().required("Campo obrigatório"),
					breed: Yup.string().required("Campo obrigatório"),
					years_old: Yup.number()
						.typeError("Apenas números")
						.positive("Não pode ser 0 ou valor negativo")
						.integer("Apenas números inteiros")
						.required("Campo obrigatório"),
					weight: Yup.number()
						.typeError("Apenas números")
						.positive("Não pode ser 0 ou valor negativo")
						.integer("Apenas números inteiros")
						.required("Campo obrigatório"),
				}),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdatePet(data);
			formPet.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formPet.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdatePet({ pet }) {
		setUpdatePet(true);

		// eslint-disable-next-line eqeqeq
		if (pet.id == false) {
			delete pet.id;

			api.post("consumer/pets/register", { pet })
				.then((res) => {
					if (res.data.status === 200) {
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}

					if (res.data.state === 500) {
						console.warn(res.data);
					}
				})
				.catch((error) => {
					console.error({
						endPoint: "consumer/pets/register",
						error,
					});
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: "Ocorreu um erro!",
					});
				})
				.finally(() => {
					getPets();
					setFormUpdatePet(false);
					setUpdatePet(false);
					setModalPopup(true);
				});
		} else {
			api.post("consumer/pets/update", { pet })
				.then((res) => {
					if (res.data.status === 200) {
						setModalContent({
							title: "Programa Fidelidade GERIOOX",
							content: res.data.message,
						});
					}
				})
				.catch((error) => {
					console.error({
						endPoint: "consumer/pets/update",
						error,
					});
				})
				.finally(() => {
					getPets();
					setFormUpdatePet(false);
					setUpdatePet(false);
					setModalPopup(true);
				});
		}
	}

	function handleDeletePet() {
		setDeletePet(true);

		if (pets.length < 2) {
			setDeletePet(false);
			setFormUpdatePet(false);
			setPopupDialog(true);
			return;
		}

		const id = formPet.current.getFieldValue("pet.id");

		api.post("consumer/pets/delete", { pet_id: id })
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				console.error({ endPoint: "consumer/pets/delete", error });
				setModalContent({
					title: "Programa Fidelidade GERIOOX",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
			})
			.finally(() => {
				getPets();
				setFormUpdatePet(false);
				setDeletePet(false);
				setModalPopup(true);
			});
	}
	// validacao imagem user
	async function handleSubmitImageProfile(data) {
		const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
		const FILE_SIZE = 500000;

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				image: Yup.mixed()
					.test(
						"fileSize",
						"A imagem é muito grande. Tamanho máxima 500KB",
						(value) => value.size <= FILE_SIZE,
					)
					.test(
						"fileType",
						"Selecione uma imagem do tipo png ou jpg.",
						(value) => SUPPORTED_FORMATS.includes(value.type),
					)
					.required("Selecione uma imagem."),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdateImageUser(data);
			formImageProfile.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formImageProfile.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdateImageUser({ image }) {
		setUpdateImageUser(true);

		const data = new FormData();
		data.append("photo", image);

		api.post("consumer/profile/photo", data)
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});

					api.get("consumer/profile")
						.then((response) => {
							localStorage.setItem(
								"@profile",
								JSON.stringify(response.data.consumer),
							);
							getUser();
						})
						.catch((error) => {
							console.error({
								endPoint: "consumer/profile",
								error,
							});
						})
						.finally(() => {
							setModalPopup(true);
							setUpdateImageUser(false);
							setFormUpdateImageProfile(false);
						});
				}

				if (res.data.status === 500) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
				}
			})
			.catch((error) => {
				console.warn({
					endPoint: "consumer/profile/photo",
					error,
				});
			});
	}

	// preparando para trabalhar imagem do pet
	function handlePopupImagePet() {
		const id = formPet.current.getFieldValue("pet.id");
		formImagePet.current.setFieldValue("id", id);
		setFormUpdatePet(false);
		setFormUpdateImagePet(true);
	}

	// validacao imagem pet
	async function handleSubmitImagePet(data) {
		const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
		const FILE_SIZE = 500000;

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				image: Yup.mixed()
					.test(
						"fileSize",
						"A imagem é muito grande. Tamanho máxima 500KB",
						(value) => value.size <= FILE_SIZE,
					)
					.test(
						"fileType",
						"Selecione uma imagem do tipo png ou jpg.",
						(value) => SUPPORTED_FORMATS.includes(value.type),
					)
					.required("Selecione uma imagem."),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdateImagePet(data);
			formImagePet.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formImagePet.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdateImagePet({ image, id }) {
		setUpdateImagePet(true);

		const data = new FormData();
		data.append("photo", image);
		data.append("id", id);

		api.post("consumer/pets/photo", data)
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
					formImagePet.current.setFieldValue("image", "");
				}

				if (res.data.status === 500) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
				}
			})
			.catch((error) => {
				console.warn({
					endPoint: "consumer/pets/photo",
					error,
				});
			})
			.finally(() => {
				getPets();
				setUpdateImagePet(false);
				setFormUpdateImagePet(false);
				setModalPopup(true);
			});
	}

	// inativando contao do usaurio
	function handleInactivatingUserAccount() {
		api.post("consumer/deactivate", { motivo })
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}

				if (res.data.status === 500) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
				}
			})
			.catch((error) => {
				console.warn({
					endPoint: "consumer/deactive",
					error,
				});

				setModalContent({
					title: "Programa Fidelidade GERIOOX",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
			})
			.finally(() => {
				setPopupDialog(false);
				setModalPopup(true);
				handleLogoutUser();
			});
	}

	// logOut
	function handleLogoutUser() {
		setLogOut(true);

		api.get("consumer/signout", {
			params: { logout: true },
		})
			.then((res) => {
				handleLogout(`${process.env.PUBLIC_URL}`);
			})
			.catch((error) => {
				console.warn({ endPoint: "consumer/signout", error });
			})
			.finally(() => {
				setLogOut(false);
			});
	}

	return (
		<React.Fragment>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(false)}
			/>
			<Container>
				<header className='header'>
					<h2>Meu perfil</h2>
					<button
						disabled={logOut ? "disabled" : ""}
						className='d-lg-none'
						onClick={() => handleLogoutUser()}>
						{logOut ? "Saindo..." : "Sair"}
					</button>
				</header>

				<article className='content'>
					<header className='content__header'>
						{/* user-image */}
						<div className='user-image'>
							{loadData ? (
								<ShimmerEffect
									width={100}
									height={100}
									border={50}
								/>
							) : (
								<img
									loading='lazy'
									src={
										user && user.image_url
											? `${process.env.REACT_APP_URL_STORE}/${user.image_url}`
											: require("@/assets/img/user-default.png")
												.default
									}
									alt='foto de perfil'
								/>
							)}

							<button
								disabled={loadData ? "disabled" : ""}
								className='edite-photo'
								onClick={() => setFormUpdateImageProfile(true)}>
								Trocar Imagem
							</button>
						</div>

						{/* user__info */}
						<div className='user__info'>
							<div className='name'>
								{loadData ? (
									<React.Fragment>
										<ShimmerEffect
											width={60}
											height={20}
											style={{ display: "inline-block" }}
										/>
										<ShimmerEffect
											width={110}
											height={20}
											style={{
												display: "inline-block",
												marginLeft: "10px",
											}}
										/>
									</React.Fragment>
								) : (
									<p>
										{user?.firstname} {user?.lastname}
									</p>
								)}
							</div>
							<div className='id'>
								{loadData ? (
									<React.Fragment>
										<ShimmerEffect
											width={60}
											height={20}
											style={{ display: "inline-block" }}
										/>
										<ShimmerEffect
											width={180}
											height={20}
											style={{
												display: "inline-block",
												marginLeft: "10px",
											}}
										/>
									</React.Fragment>
								) : (
									<p>CPF: {user?.cpf}</p>
								)}
							</div>
						</div>
					</header>
					{/* informacoes do usuario */}
					<div className='content__body'>
						<table className='table_info'>
							<tbody>
								<tr>
									<td>E-mail</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											user?.email
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Telefone</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											user?.phone
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Endereço</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											<span>
												CEP:{" "}
												{user?.localization?.zip_code}
											</span>
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Pet 1</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											<React.Fragment>
												<img
													width={30}
													height={30}
													loading='lazy'
													src={
														pets && pets[0]?.photo
															? `${process.env.REACT_APP_URL_STORE}/${pets[0]?.photo}`
															: require("@/assets/img/user-default.png")
																.default
													}
													alt='foto pet'
													style={{
														marginRight: "10px",
														borderRadius: "50%",
													}}
												/>
												{pets && (
													<span>{pets[0]?.name}</span>
												)}
											</React.Fragment>
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													handleSetFormPet("0")
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Pet 2</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : pets && pets[1]?.name ? (
											<React.Fragment>
												<img
													width={30}
													height={30}
													loading='lazy'
													src={
														pets && pets[1]?.photo
															? `${process.env.REACT_APP_URL_STORE}/${pets[1]?.photo}`
															: require("@/assets/img/user-default.png")
																.default
													}
													alt='foto pet'
													style={{
														marginRight: "10px",
														borderRadius: "50%",
													}}
												/>
												{pets && (
													<span>{pets[1]?.name}</span>
												)}
											</React.Fragment>
										) : (
											<button
												className='add-new-pet'
												onClick={() =>
													handleSetFormPet("1")
												}>
												Adicionar novo pet
											</button>
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													handleSetFormPet("1")
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Senha</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											"••••••••"
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
							</tbody>
						</table>
						<div className='profile-actions'>
							<button
								className='btn-primary'
								disabled={loadData ? "disabled" : ""}
								onClick={() => setFormUpdateProfile(true)}>
								Editar perfil
							</button>
							<button
								disabled={loadData ? "disabled" : ""}
								className='btn-secundary no-spotlight'
								onClick={() => setPopupDialog(true)}>
								Descadastrar do programa
							</button>
						</div>
					</div>
				</article>

				<article
					style={{ display: formUpdateProfile ? "flex" : "none" }}
					className='popup-form-profile'>
					<div className='popup-form-profile__content'>
						<Form
							ref={formRef}
							name='updateUser'
							onSubmit={handleSubmit}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() => setFormUpdateProfile(false)}
								/>
								<h3>Dados do perfil</h3>
								<Scope path='consumer'>
									<Input
										label='Nome*'
										name='firstname'
										placeholder='Digite seu nome'
									/>
									<Input
										label='Sobrenome*'
										name='lastname'
										placeholder='Digite seu sobrenome'
									/>
									<InputMask
										label='CPF*'
										name='cpf'
										mask='999.999.999-99'
										placeholder='000.000.000-00'
									/>
									<Input
										label='E-mail*'
										name='email'
										placeholder='user@mail.com'
									/>
									<Input
										type='password'
										label='Nova Senha'
										name='password'
										placeholder='Digite uma senha'
									/>
									<Input
										type='password'
										label='Confirmar senha'
										name='passwordConfirmation'
										placeholder='Re-digite sua senha'
									/>
									<Input
										type='text'
										label='Telefone*'
										name='phone'
										placeholder='(00) 00000-0000'
										onChange={maskPhone}
										maxLength="15"
									/>
									<Scope path='address_components'>
										<div className='center-items'>
											<InputMask
												label='CEP*'
												name='zip_code'
												mask='99999-999'
												placeholder='00000-000'
												onChange={handleInputComplete}
											/>
											<a
												href='//www.buscacep.correios.com.br/sistemas/buscacep/'
												target='_blank'
												rel='noopener noreferrer'
												className='text-spotlight'>
												Não sei o CEP
											</a>
										</div>
										<Input
											label='Endereço*'
											name='address'
											placeholder='Digite seu endereço'
										/>
										<div>
											<Input
												label='Número*'
												name='number'
												placeholder='ex: 1234'
											/>
											<Input
												label='Complemento'
												name='complement'
												placeholder='ex: casa, depto, sala'
											/>
										</div>
										<Input
											label='Bairro*'
											name='district'
											placeholder='Digite seu bairro'
										/>
										<div>
											<Input
												label='Cidade*'
												name='city'
												placeholder='Digite sua cidade'
											/>
											<InputSelect
												label='Estado*'
												name='state'
											/>
										</div>
									</Scope>
								</Scope>
								<p>* Campos obrigatórios.</p>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updateProfile ? "disabled" : ""
										}
										className='btn-primary'>
										{updateProfile
											? "Atualizando cadastro"
											: "Atualizar cadastro"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>

				<article
					className='popup-form-pets'
					style={{ display: formUpdatePet ? "flex" : "none" }}>
					<div className='popup-form-pets__content'>
						<Form
							ref={formPet}
							name='updatePet'
							onSubmit={handleSubmitPet}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() => setFormUpdatePet(false)}
								/>
								<img
									className='image_pet'
									width={60}
									height={60}
									loading='lazy'
									src={
										pets && pets[petIndex]?.photo
											? `${process.env.REACT_APP_URL_STORE}/${pets[petIndex]?.photo}`
											: require("@/assets/img/user-default.png")
												.default
									}
									alt='foto pet'
									style={{
										borderRadius: "50%",
										display: petHasID ? "block" : "none",
									}}
									onClick={() => handlePopupImagePet()}
								/>
								<h3>Dados do pet</h3>
								<Scope path='pet'>
									<Input
										label={false}
										name='id'
										hidden='hidden'
									/>
									<Input
										label='Nome do animal*'
										name='name'
										placeholder='Ex: Bob'
									/>
									<InputSelectDinamic
										label='Espécie*'
										name='kind'
										optionType='uma espécie'
										data={list?.kinds}
									/>
									<InputSelectDinamic
										label='Raça*'
										name='breed'
										optionType='uma raça'
										data={list?.breeds}
									/>
									<div>
										<Input
											label='Idade do animal em anos*'
											name='years_old'
											placeholder='0'
										/>
										<Input
											label='Peso do animal em quilos*'
											name='weight'
											placeholder='0 kg (Apenas números)'
										/>
									</div>
									<InputSelectDinamic
										label='Diagnóstico clínico ou motivo para utilização do Gerioox'
										name='diagnostic'
										optionType='um diagnóstico'
										data={[
											{ id: 1, name: "Tratamento renal" },
											{ id: 2, name: "Tratamento neurológico" },
											{ id: 3, name: "Tratamento cardíaco" },
											{ id: 4, name: "Prevenção" },
											{ id: 5, name: "Outros" },
										]}
									/>
									<Input
										label='Digite o nome do Médico Veterinário'
										name='vet'
										placeholder='Nome do veterinário'
									/>
								</Scope>
								<p>* Campos obrigatórios.</p>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updatePet || deletePet
												? "disabled"
												: ""
										}
										className='btn-primary'>
										{updatePet
											? "Salvando dados do pet"
											: "Salvar dados do pet"}
									</button>
								</div>
								<div
									style={{
										display: petHasID ? "flex" : "none",
									}}
									className='block-submit'>
									<button
										type='button'
										disabled={
											deletePet || updatePet
												? "disabled"
												: ""
										}
										className='btn-secundary'
										onClick={() => handleDeletePet()}>
										{deletePet
											? "Excluindo Pet"
											: "Excluir Pet"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>

				<article
					style={{
						display: formUpdateImageProfile ? "flex" : "none",
					}}
					className='popup-form-image-profile'>
					<div className='popup-form-image-profile__content'>
						<Form
							ref={formImageProfile}
							name='updateImageProfile'
							onSubmit={handleSubmitImageProfile}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() =>
										setFormUpdateImageProfile(false)
									}
								/>
								<h3>Imagem do perfil</h3>
								<label className='label_image'>
									<div className='button-wrapper'>
										<span className='label'>
											Carregar imagem <span>(Tamanho máxima 500KB)</span>
										</span>
										<InputFile
											name='image'
											id='upload'
											className='upload-box'
											placeholder='Upload File'
											accept='image/png, image/jpeg'
										/>
									</div>
								</label>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updateImageUser ? "disabled" : ""
										}
										className='btn-primary'>
										{updateImageUser
											? "Salvando"
											: "Salvar"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>

				<article
					style={{
						display: formUpdateImagePet ? "flex" : "none",
					}}
					className='popup-form-image-pet'>
					<div className='popup-form-image-pet__content'>
						<Form
							ref={formImagePet}
							name='updateImagePet'
							onSubmit={handleSubmitImagePet}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() => setFormUpdateImagePet(false)}
								/>
								<h3>Imagem do pet</h3>
								<Input
									label={false}
									name='id'
									hidden='hidden'
								/>
								<label className='label_image'>
									<div className='button-wrapper'>
										<span className='label'>
											Carregar imagem <span>(Tamanho máxima 500KB)</span>
										</span>
										<InputFile
											name='image'
											id='upload'
											className='upload-box'
											placeholder='Upload File'
											accept='image/png, image/jpeg'
										/>
									</div>
								</label>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updateImagePet ? "disabled" : ""
										}
										className='btn-primary'>
										{updateImagePet ? "Salvando" : "Salvar"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>

				<article
					className='popup-dialog'
					style={{
						display: popupDialog ? "flex" : "none",
					}}>
					<div className='popup-dialog__content'>
						<dialog open id='favDialog'>
							<section>
								<form onSubmit={() => { }}>
									<p>
										Que pena que você deseja sair do
										programa! ☹{" "}
									</p>
									<label>
										<span>Motivo: </span>
										<select
											name='motivo'
											onChange={(e) =>
												setMotivo(e.target.value)
											}
											value={motivo}>
											<option value=''>
												Selecione uma opção
											</option>
											<option value='Óbito'>Óbito</option>
											<option value='Reação Adversa'>
												Reação Adversa
											</option>
											<option value='Suspensão do uso'>
												Suspensão do uso
											</option>
											<option value='Outros'>
												Outros
											</option>
										</select>
									</label>
								</form>

								<p>
									Sua conta será inativada.{" "}
									<strong>Deseja</strong> continuar?”
								</p>
							</section>
							<menu>
								<button
									className='btn-primary'
									onClick={() => setPopupDialog(false)}>
									Não
								</button>
								<button
									disabled={motivo ? "" : "disabled"}
									className='btn-secundary'
									onClick={() =>
										handleInactivatingUserAccount()
									}>
									Sim
								</button>
							</menu>
						</dialog>
					</div>
				</article>
			</Container>
		</React.Fragment>
	);
};

export default Profile;
